import { jsxs as t, jsx as i } from "react/jsx-runtime";
import { memo as l } from "react";
import { u as d } from "../styled-components.browser.esm-3eb04950.js";
import { ColoredCard as c, CardEffectDiv as f } from "../themes/SharedStyledComponent.js";
import { Action as s } from "../list/Action.js";
import { ContentTitle as x } from "./Content.Title.js";
import { P as h } from "../useResizeDetector-1ae5f4fb.js";
const D = l(({
  title: e,
  actions: r,
  contentBgColor: p = "white",
  children: m,
  width: n
}) => {
  const o = h();
  return /* @__PURE__ */ t(C, { $width: n, children: [
    /* @__PURE__ */ t(u, { $isMedia: o, children: [
      /* @__PURE__ */ i(x, { children: e }),
      /* @__PURE__ */ i(s, { $isMedia: o, children: r == null ? void 0 : r.map((a) => a) })
    ] }),
    /* @__PURE__ */ i(c, { $color: p, children: m })
  ] });
}), C = d(f)`
    padding: 25px;
    width: ${({ $width: e }) => e || "calc(100% - 40px)"};
    height: calc(100% - 15px);
    display: flex;
`, u = d.div`
    display: flex;
    flex-direction: ${({ $isMedia: e }) => e ? "row" : "column"};
    justify-content: space-between;
    padding: 0 0 20px 0;
`;
export {
  D as default
};
//# sourceMappingURL=Content.Card.js.map
